var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 26.994,
    viewBox: "0 0 36 26.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8241",
    "data-name": "Group 8241",
    transform: "translate(-230 -98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    "data-name": "Path 3435",
    d: "M30.174,30H5.826C2.621,30,0,27.119,0,23.6V7.951a.75.75,0,0,1,1.137-.7L14.894,16.4a5.542,5.542,0,0,0,6.212,0L34.863,7.247a.75.75,0,0,1,1.137.7V23.6c0,3.521-2.622,6.4-5.826,6.4",
    transform: "translate(230 94.993)",
    fill: "#e62e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    "data-name": "Path 3436",
    d: "M20,8.545,31.623,3.918c.7-.28.357-.911-.5-.911H4.877c-.858,0-1.2.631-.5.911L16,8.545a5.749,5.749,0,0,0,4,0",
    transform: "translate(230 94.993)",
    fill: "#e62e2e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMail);
export default __webpack_public_path__ + "static/media/RedMail.345ad083ad76506dcea8024b2e71b65c.svg";
export { ForwardRef as ReactComponent };